import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Entry } from 'contentful';
import { SandboxPage } from 'src/app/model/page/sandbox-page';
import { AirlineFilter, AirlineOffersScreen } from 'src/app/model/screen/airline-offers-screen';
import { boundSlider, FilterOffersScreen } from 'src/app/model/screen/filter-offers-screen';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-filter-offers-screen',
  templateUrl: './filter-offers-screen.component.html',
  styleUrls: ['./filter-offers-screen.component.scss']
})
export class FilterOffersScreenComponent implements OnInit {
  filterOffersScreen: FilterOffersScreen = {} as FilterOffersScreen;

  showInbound: boolean = false;

  public airLineFilterForm: any = 1;
  minValue: number = 0;
  maxValue: number = 2400;
  boundSliders: boundSlider[] = [];

  timeSliderOprion: Options = {
    floor: 0,
    ceil: 2400,
    step: 15,
    showSelectionBar: true,

    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return this.mapTime(value);
        case LabelType.High:
          return this.mapTime(value);
        default:
          return this.mapTime(value);
      }
    }
  };

  mapTime(slideValue: number) {
    let slideValueToTime: any = (slideValue / 100).toFixed(2);
    slideValueToTime = slideValueToTime.toString();

    slideValueToTime = slideValueToTime.split('.');

    let hour = parseInt(slideValueToTime[0]);

    let min = slideValueToTime[1];

    if (typeof min === 'undefined') {
      min = '00';
    } else {
      min = parseInt(min);
      if (min === 60) {
        hour = hour + 1;
        min = '00';
      } else if (min > 60) {
        hour = hour + 1;
        min = min - 60;
      }
    }
    let hourToString: any = hour.toString();
    if (hourToString.length == 1) {
      hourToString = '0' + hourToString;
    }
    let minToString: any = min.toString();
    if (minToString.length == 1) {
      minToString = '0' + minToString;
    }
    return hourToString + ':' + minToString;
  }
  //end

  sandboxPage: SandboxPage = {} as SandboxPage;
  value: number = 0;
  highValue: number = 60;

  constructor(private sandboxPageStateService: SandboxPageStateService, private formBuilder: FormBuilder, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    //filter function
    this.airLineFilterForm = this.initAirlineFilterForm();
    //end
    const query = { 'fields.title': 'Sandbox' };
    this.contentfulService.getPageContentWithEntries(query).then((loginPageEntries) => {
      this.mapBanner(loginPageEntries);
    });

    this.sandboxPageStateService.isSearchFliterRefreshState.subscribe((res: boolean) => {
      if (res) {
        this.initAirlineFilterForm();
      }
    });
    let resfreshSearchFilterScreen = false;
    this.sandboxPageStateService.updateisSearchFliterRefresh(resfreshSearchFilterScreen);
  }

  private mapBanner(loginPageEntries: Entry<any>[]) {
    loginPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.sandboxPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url as string
    };
  }
  //filter function
  update_filter() {
    this.updateFilterFormInSandbox();
    let patchSandboxSourceData = { mainMenu: 'none', sandboxScreen: 'filter-offers-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  initAirlineFilterForm() {
    let airlineOffersScreen: AirlineOffersScreen = this.sandboxPageStateService.getAirlineOffersScreenData();
    let airLineFilterData: AirlineFilter = airlineOffersScreen.airlineFilterData;
    let airLineSelectedFilterData = this.sandboxPageStateService.getFilterOffersScreenData();
    let searchflightScreenData = this.sandboxPageStateService.getSearchFlightFormValue();
    this.showInbound = searchflightScreenData.haveReturn;
    let selAirports = airLineSelectedFilterData.airportList;
    let selPricesClass = airLineSelectedFilterData.priceClassList;
    let selOperators = airLineSelectedFilterData.operaterList;
    let boundSliders = airLineSelectedFilterData.boundSliders;
    this.boundSliders = boundSliders;
    let airPort = this.formBuilder.array([]);
    let airportList = airLineFilterData.airportList;
    let airportListLen = airportList.length;
    if (airportListLen > 0) {
      airportList.forEach((y: any) => {
        let sel = true;
        if (selAirports.indexOf(y) === -1) {
          sel = false;
        }
        let groupData: any = this.formBuilder.group({
          label: [y],
          selected: [sel]
        });
        airPort.push(groupData);
      });
    }
    let operater = this.formBuilder.array([]);
    let OperaterList = airLineFilterData.operaterList;
    let OperaterListLen = OperaterList.length;
    if (OperaterListLen > 0) {
      OperaterList.forEach((y: any) => {
        let sel = true;
        if (selOperators.indexOf(y) === -1) {
          sel = false;
        }
        let groupData: any = this.formBuilder.group({
          label: [y],
          selected: [sel]
        });
        operater.push(groupData);
      });
    }
    let priceClass = this.formBuilder.array([]);
    let priceClassList = airLineFilterData.priceClassList;
    let priceClassListLen = priceClassList.length;
    if (priceClassListLen > 0) {
      priceClassList.forEach((y: any) => {
        let sel = true;
        if (selPricesClass.indexOf(y) === -1) {
          sel = false;
        }
        let groupData: any = this.formBuilder.group({
          label: [y],
          selected: [sel]
        });
        priceClass.push(groupData);
      });
    }

    let boundSlidersFormArray = this.formBuilder.array([]);
    boundSliders.forEach((boundSlider: boundSlider) => {
      let boundSlidersFormGroup: any = this.formBuilder.group({
        startTime: [boundSlider.startTime],
        endTime: [boundSlider.endTime]
      });
      boundSlidersFormArray.push(boundSlidersFormGroup);
    });
    return this.formBuilder.group({
      boundSliders: boundSlidersFormArray,
      airPort: airPort,
      priceClass: priceClass,
      operater: operater
    });
  }
  inp_group(controlName: any) {
    return this.airLineFilterForm.controls[controlName];
  }
  inp_arr(controlName: any) {
    return this.inp_group(controlName) as FormArray;
  }
  inp_arr_group(controlName: any, i: any) {
    return this.inp_arr(controlName).at(i) as FormGroup;
  }
  inp_arr_group_value(arrayName: any, i: any, key: any) {
    return this.inp_arr_group(arrayName, i).value[key];
  }
  closePannel() {
    this.updateFilterFormInSandbox();
    let patchSandboxSourceData = { sideMenu: 'searchOffer' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  updateFilterFormInSandbox() {
    let filterFormValue = this.airLineFilterForm.value;
    let airportList = filterFormValue.airPort;
    let airportListLen = airportList.length;
    let selAirports: any = [];
    if (airportListLen > 0) {
      airportList.forEach((y: any) => {
        if (y.selected) {
          selAirports.push(y.label);
        }
      });
    }
    let operaterList = filterFormValue.operater;
    let operaterListLen = operaterList.length;
    let selOperaters: any = [];
    if (operaterListLen > 0) {
      operaterList.forEach((y: any) => {
        if (y.selected) {
          selOperaters.push(y.label);
        }
      });
    }
    let priceClassList = filterFormValue.priceClass;
    let priceClassLen = priceClassList.length;
    let selPriceClass: any = [];
    if (priceClassLen > 0) {
      priceClassList.forEach((y: any) => {
        if (y.selected) {
          selPriceClass.push(y.label);
        }
      });
    }
    this.boundSliders.forEach((boundSlider: boundSlider) => {
      boundSlider.startTime = boundSlider.startTime.toString().length === '1' ? '0' + boundSlider.startTime : boundSlider.startTime;
      boundSlider.endTime = boundSlider.endTime.toString().length === '1' ? '0' + boundSlider.endTime : boundSlider.endTime;
    });
    this.filterOffersScreen = {
      airportList: selAirports,
      priceClassList: selPriceClass,
      operaterList: selOperaters,
      boundSliders: this.boundSliders
    };
    this.sandboxPageStateService.updateFilterOffersScreenData(this.filterOffersScreen);
  }
  //end
}
